"use client";

import * as React from 'react';
const ToastContext = /*#__PURE__*/React.createContext({
  onClose() {}
});
export default ToastContext;